import { MultiplicityPatterns } from './MultiplicityPatterns';
MultiplicityPatterns.sort((a, b) => a.multiplicity !== null && b.multiplicity !== null
    ? a.multiplicity - b.multiplicity
    : Number.MAX_SAFE_INTEGER);
export const couplingPatterns = MultiplicityPatterns.map((m) => m.value);
export const couplingACSPatterns = MultiplicityPatterns.map((m) => m.acs || m.value);
//# sourceMappingURL=couplingPatterns.js.map